<template>

  <div
    id="receipt"
    class="vpay__content-area"
  >

    <h2
      class="vpay__title-bar"
      :class="{ 'vpay__title-bar--collapsed': !$store.getters.showReceiptBackButton }"
    >
      <div
        v-if="$store.getters.showReceiptBackButton"
        class="vpay__icon-button vpay__title-bar-close"
      ><ion-icon
          name="arrow-back"
          @click="onClickClose"
        ></ion-icon></div>
      <span>Receipt <ion-icon
          v-if="receipt.receipt_number"
          class="vpay__receipt-verified"
          name="checkmark-circle"
        ></ion-icon></span>
      <div class="vpay__icon-button vpay__title-bar-print"><ion-icon
          name="print"
          @click="onClickPrint"
        ></ion-icon></div>
    </h2>

    <div
      v-loading="!receipt.receipt_number"
      class="vpay__receipt"
    >

      <el-row class="vpay__receipt-row">
        <el-col :span="12">
          <p class="vpay__receipt-number">No {{ receipt.receipt_number }}</p>
        </el-col>
      </el-row>

      <br>

      <el-row class="vpay__receipt-section">
        <el-col :span="24">
          <h3 class="vpay__receipt-title">{{ receipt.description }}</h3>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="12"
        >
          <p>Amount paid</p>
        </el-col>
        <el-col
          class="vpay__receipt-col-right"
          :span="12"
        >
          <p>{{ receipt.amount | formatAmount(receipt.currency) }}</p>
          <p style="font-size: 12px;">{{ taxInformation }}</p>
          <p
            v-if="isGift"
            style="font-size: 12px;"
          >This is a tax deductible gift</p>
          <p
            v-if="userPaidFees"
            style="font-size: 12px;"
          >You paid the credit card fee</p>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="12"
        >
          <p>Date paid</p>
        </el-col>
        <el-col
          class="vpay__receipt-col-right"
          :span="12"
        >
          <p>{{ receipt.date | formatTimestamp }}</p>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="12"
        >
          <p>Type</p>
        </el-col>
        <el-col
          class="vpay__receipt-col-right"
          :span="12"
        >
          <p>{{ type }}</p>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="12"
        >
          <p>Notes</p>
        </el-col>
        <el-col
          class="vpay__receipt-col-right"
          :span="12"
        >
          <p v-if="receipt.notes">{{ receipt.notes }}</p>
          <p v-else>-</p>
        </el-col>
      </el-row>

      <br>

      <el-row class="vpay__receipt-section">
        <el-col :span="24">
          <h3 class="vpay__receipt-title">{{ receipt.first_name }} {{ receipt.last_name }}</h3>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="24"
        >
          <p><ion-icon name="pin"></ion-icon>{{ receipt | formatAddress }}</p>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="24"
        >
          <p><ion-icon name="mail"></ion-icon> {{ receipt.email }}</p>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="24"
        >
          <p><ion-icon name="phone-portrait"></ion-icon> {{ receipt.phone | formatMobileNumber }}</p>
        </el-col>
      </el-row>

      <el-row class="vpay__receipt-row">
        <el-col
          class="vpay__receipt-col-left"
          :span="24"
        ><span class="vpay__receipt-card"><img :src="cardImageSrc"><span>Ending {{ cardNumberFormat }}</span></span></el-col>
      </el-row>

      <br>

      <el-row>
        <el-col
          class="vpay__receipt-col-left"
          :span="12"
        >
          <p class="vpay__receipt-org-info">{{ $store.getters.account.information.trading_name }}</p>
          <p class="vpay__receipt-org-info">ABN / ACN: {{ $store.getters.account.information.legal_entity_number }}</p>
        </el-col>
        <el-col
          class="vpay__receipt-col-right"
          :span="12"
        >
          <p class="vpay__receipt-org-info">{{ $store.getters.account.information.address_1 }}</p>
        </el-col>
      </el-row>

      <el-row v-if="$store.getters.account.information.acnc_registered">
        <img
          class="acnc__logo"
          src="https://pay.vinteract.com.au/assets/logos/organisations/acnc.png"
          alt="Australian Charities and Not-for-profits Commission"
        >
      </el-row>

    </div>

    <footer v-if="!$store.getters.showFooter">
      <p class="powered-by">Powered by {{ $store.getters.platform.name }}</p>
    </footer>

  </div>

</template>

<script>
import { Printd } from "printd";

import html2canvas from "html2canvas";

export default {
  name: "TransactionReceipt",

  computed: {
    isGift() {
      return (
        this.$store.getters.account.information.dgr_registered &&
        this.receipt.is_gift
      );
    },

    userPaidFees() {
      return this.receipt.user_paid_fees;
    },

    taxInformation() {
      if (!this.receipt.is_gift && this.receipt.includes_tax) {
        return `Includes ${this.taxAmount} GST`;
      }
      return "GST Free";
    },

    taxAmount() {
      return this.$options.filters.formatAmount(
        this.receipt.amount / 11,
        this.receipt.currency,
        false
      );
    },

    cardImageSrc() {
      return `https://www.redde.com.au/assets/logos/cards/${this.receipt.card_type}.png`;
    },

    type() {
      let type = this.receipt.frequency;
      let interval = this.receipt.interval;

      if (type === "recurring") {
        type = `${this.$options.filters.formatFrequencyType(
          type
        )} (${this.$options.filters.formatFrequencyInterval(interval)})`;
      } else {
        type = this.$options.filters.formatFrequencyType(type);
      }

      return type;
    },

    // Bug fix LEG-257 26/04/2022
    // backend pass the numberic data to frontend, so there will be an issue
    // that a string starts with 0, it will be converted to a number.
    // e.g. 0430 will be 430, so we need to add 0 in front of it
    cardNumberFormat() {
      let cardNumber = this.receipt.card_last_4;

      cardNumber = cardNumber.toString();

      var carNumber_length = cardNumber.length;

      if (carNumber_length < 4) {
        for (let i = 0; i < 4 - carNumber_length; i++) {
          cardNumber = "0" + cardNumber;
        }
      }

      return cardNumber;
    },
  },

  methods: {
    onClickClose() {
      this.$store.commit("displayComponentName", null);
    },

    onClickPrint() {
      html2canvas(document.getElementById("receipt")).then(function (canvas) {
        // Create image.
        const img = new Image();
        img.src = canvas.toDataURL("image/png");
        // Print image.
        window.print(img);
      });

      //   html2canvas(document.getElementById("receipt"), {
      //     onclone: (document) => {},
      //   }).then((canvas) => {
      //     // Create image.
      //     const img = new Image();
      //     img.src = canvas.toDataURL("image/png");
      //     // Print image.
      //     const p = new Printd();
      //     p.print(img);
      //   });
    },
  },

  created() {
    this.axios
      .get(`receipts/${this.receiptNumber}`, {
        headers: this.$store.getters.requestHeaders,
      })
      .then((r) => {
        if (r.data.success) {
          this.$set(this, "receipt", r.data.results[0]);
        }
      });
  },

  data() {
    return {
      receiptNumber: this.$store.getters.receiptNumber,
      receipt: {},
    };
  },
};
</script>

<style scoped>
.vpay__receipt p {
  font-size: 14px;
  font-weight: 500;
}

.vpay__receipt-verified {
  margin: 0;
  top: 0;
  color: #67c23a;
}

.vpay__receipt-section {
  padding-bottom: 16px;
  margin-bottom: 8px;
}

.vpay__receipt-row {
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.vpay__receipt-col-left {
}

.vpay__receipt-col-right {
  text-align: right;
}

.vpay__receipt-number {
  color: #409eff;
}

.vpay__receipt-title {
  margin: 0;
}

.vpay__receipt-card {
  overflow: auto;
}

.vpay__receipt-card img {
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  height: 24px;
  float: left;
  margin-right: 8px;
}

.vpay__receipt-card span {
  float: left;
  line-height: 24px;
  font-size: 14px;
  font-weight: 500;
}

.vpay__receipt-org-info {
  font-size: 12px;
  margin-bottom: 6px;
  opacity: 0.5;
}

.acnc__logo {
  margin: 0 auto;
  margin-top: 16px;
  display: block;
  opacity: 0.5;
  transition: opacity 100ms;
  width: 100px;
  height: 100px;
}

.acnc__logo:hover {
  opacity: 1;
}

.powered-by {
  margin: 0;
}
</style>
